import {
  CheckCircleOutlined,
  FileTextOutlined,
  FolderOutlined,
  ToolOutlined,
} from '@ant-design/icons';
import { Space, Typography, theme } from 'antd';
import { useDocumentosCounts } from 'hooks/useApi/useDocumentosApi';

const { useToken } = theme;
const { Text } = Typography;

const TILES = [
  {
    key: 'presupuestos',
    label: 'Presupuestos',
    countKey: 'presupuestos',
    icon: FileTextOutlined,
    tintKey: 'colorPrimary',
  },
  {
    key: 'comprobantes',
    label: 'Comprobantes',
    countKey: 'comprobantes',
    icon: CheckCircleOutlined,
    tintKey: 'colorWarning',
  },
  {
    key: 'mantenciones',
    label: 'Mantenciones',
    countKey: 'mantenciones',
    icon: ToolOutlined,
    tintKey: 'colorSuccess',
  },
  {
    key: 'mantencionesDep',
    label: 'Mantenciones Dep.',
    countKey: 'mantencionesDeprecadas',
    icon: FolderOutlined,
    tintKey: 'colorInfo',
  },
];

function Tile({ tile, count, active, tint, onClick }) {
  const { token } = useToken();
  const Icon = tile.icon;
  return (
    <button
      type="button"
      onClick={() => onClick(tile.key)}
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 6,
        padding: token.paddingMD,
        minWidth: 180,
        flex: '1 1 180px',
        textAlign: 'left',
        cursor: 'pointer',
        border: `1px solid ${active ? tint : token.colorBorder}`,
        borderRadius: token.borderRadiusLG,
        background: active ? tint + '14' : token.colorBgContainer,
        boxShadow: active ? `0 0 0 2px ${tint}33` : 'none',
        transition: 'all 0.15s ease',
      }}
    >
      <Space>
        <Icon style={{ color: tint, fontSize: 18 }} />
        <Text type="secondary" style={{ fontSize: 13 }}>
          {tile.label}
        </Text>
      </Space>
      <Text strong style={{ fontSize: 26, color: tint, lineHeight: 1 }}>
        {count}
      </Text>
    </button>
  );
}

function DocumentosKpiStrip({ activeType, onSelect, refreshKey = 0 }) {
  const { token } = useToken();
  const { counts } = useDocumentosCounts(refreshKey);

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: token.marginSM }}>
      {TILES.map((tile) => (
        <Tile
          key={tile.key}
          tile={tile}
          count={counts[tile.countKey] ?? 0}
          active={activeType === tile.key}
          tint={token[tile.tintKey]}
          onClick={onSelect}
        />
      ))}
    </div>
  );
}

export default DocumentosKpiStrip;
